module.exports = __webpack_public_path__ + "img/enterprise-api-hub-overview.120b2467.svg";